import React from "react"
import { Link } from "gatsby"
import { Nav, Dropdown, NavItem } from "react-bootstrap"
import "./menu.css"
import logo from "../../images/logo.png"

export default ({ toggleMenu }) => (
  <div className="navigation">
    <Link to="/">
      <img
        src={logo}
        title="Management Insight"
        style={{
          maxWidth: "205px",
          paddingBottom: "10px",
        }}
      />
    </Link>
    <div className="d-block text-center mt-2">
      {" "}
      {/* <a
        href="#"
        style={{
          fontSize: "12px",
          color: "#000",
        }}
      >
        <i className="fa fa-envelope-o text-teal mr-2"></i>
        &nbsp;todd@managementinsight.co
      </a>
      <br /> */}
      <a
        href="tel:3038838001"
        style={{
          fontSize: "12px",
          color: "#000",
        }}
      >
        <i className="fa fa-phone text-teal mr-2" />
        &nbsp;303.883.8001
        <br />
      </a>
    </div>
    <div className=" mt-3 text-center mb-2">
      <a
        href="https://www.facebook.com/toddasana.co/"
        target="_blank"
        rel="noreferrer"
      >
        <i
          className="fa fa-facebook-f mr-3"
          style={{
            fontSize: "15px",
            color: "#000",
            border: "1px solid #000",
            padding: "6px 9px",
            borderRadius: "100%",
          }}
        />
      </a>
      <a
        href="https://www.linkedin.com/in/toddwheeler/"
        target="_blank"
        rel="noreferrer"
      >
        <i
          className="fa fa-linkedin"
          style={{
            fontSize: "15px",
            color: "#000",
            border: "1px solid #000",
            padding: "6px 7px",
            borderRadius: "100%",
          }}
        />
      </a>
    </div>
    <Nav className="flex-column text-center">
      <Nav.Item>
        <Link to="/">Home</Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/about-us">About Us</Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/what-we-do">What We Do</Link>
      </Nav.Item>
      <Nav.Item>
        <Link to="/executive-and-leadership-coaching">
          Leadership and Executive Coaching
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Dropdown as={NavItem}>
          <Dropdown.Toggle as={Nav.Link}>
            <Link
              to="/risk-assessment-and-development-tools"
              onClick={toggleMenu}
            >
              Risk Assessments and
              <br />
              Development tools
            </Link>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu">
            {/* <Link className="dropdown-item" to="/">
              Business Coaching
            </Link>
            <Link className="dropdown-item" to="/">
              Individual and Personal Coaching
            </Link>
            <Link className="dropdown-item" to="/">
              Personal/Physical Training - Yoga
            </Link>
            <Link className="dropdown-item" to="/">
              The Millenial Project
            </Link> */}
            <Link
              className="dropdown-item"
              to="/risk-assessment-and-development-tools/#corporate-cat-scan"
              onClick={toggleMenu}
            >
              The Corporate Cat-Scan
            </Link>
            <Link
              className="dropdown-item"
              to="/risk-assessment-and-development-tools/#blindspot"
              onClick={toggleMenu}
            >
              Individual and Corporate
              <br />
              Blind Spots Assessment
            </Link>
            <Link
              className="dropdown-item"
              to="/risk-assessment-and-development-tools/#vision-traction-planner"
              onClick={toggleMenu}
            >
              Vision/Traction Planner
            </Link>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Link to="/reviews">Reviews</Link>
      </Nav.Item>
      <Nav.Item>
        <Dropdown as={NavItem}>
          <Dropdown.Toggle as={Nav.Link}>
            <Link>Resources</Link>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu">
            {/* <Link className="dropdown-item" to="/">
              Business Coaching
            </Link>
            <Link className="dropdown-item" to="/">
              Individual and Personal Coaching
            </Link>
            <Link className="dropdown-item" to="/">
              Personal/Physical Training - Yoga
            </Link>
            <Link className="dropdown-item" to="/">
              The Millenial Project
            </Link> */}
            <Link className="dropdown-item" to="/worksheet">
              Worksheet
            </Link>
            {/* <Link className="dropdown-item" to="/blog">
              Blog
            </Link> */}

            <a
              className="dropdown-item"
              href="http://www.themillennialproject.co/"
              target="_blank"
              rel="noreferrer"
            >
              The Millennial Project
            </a>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Link to="/contact-us">Contact Us</Link>
      </Nav.Item>
    </Nav>
  </div>
)
